<a
  [href]="
    document().fileType.startsWith('LMA_')
      ? null
      : (document().id | fileSignedUrl: organizationID())
  "
  target="_blank"
  rel="noopener noreferrer"
  download
>
  <ng-content />
</a>
